import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderDashboard from '../Components/HeaderDashboard';
import { GetApprovalDetails } from '../Services/ApprovalAPI';
// import { AcceptApprovalRequest } from '../Services/ApprovalAPI';
// import { RejectApprovalRequest } from '../Services/ApprovalAPI';
import BusApprovalDetail from '../Dashboard/BusApprovalDetail';
import FlightApprovalDetail from '../Dashboard/FlightApprovalDetail';
import HotelApprovalDetail from '../Dashboard/HotelApprovalDetail';
import InsuranceApprovalDetail from '../Dashboard/InsuranceApprovalDetail';

const ApprovalDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const referenceNo = queryParams.get("referenceNo");
    const productType = queryParams.get("productType");

    const [approvalDetails, setApprovalDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [remark, setRemark] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);

    const hasCalled = useRef(false);

    useEffect(() => {
        if (referenceNo) {
            if (hasCalled.current) return;
            hasCalled.current = true;
            fetchApprovalDetails(referenceNo);
        } else {
            console.warn("Missing referenceNo and trackId");
        }
    }, [referenceNo]);

    const fetchApprovalDetails = async (referenceNo) => {
        try {
            setLoading(true);
            setError("");
            const response = await GetApprovalDetails(referenceNo, productType);
            setApprovalDetails(response.approvalDetails);
            //console.log("setApprovalDetails", response.approvalDetails)


        } catch (err) {
            setError("Failed to load flight Requested Approval details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // const SubmitAcceptApprovalRequest = async (item) => {
    //     if (!item) {
    //         alert("Invalid approval data");
    //         return;
    //     }
    //     const { referenceNo, level1Approver, level1ApproverEmail, userId } = item;
    //     if (!referenceNo || !level1ApproverEmail) {
    //         alert("Missing required data");
    //         return;
    //     }
    //     setLoading(true);
    //     try {
    //         const requestBody = {
    //             referenceNo: referenceNo,
    //             level1ApproverEmal: level1ApproverEmail,
    //             level1Approver,
    //             product: "Flight",
    //             UserId: userId,
    //         };
    //         //console.log("requestBody:", requestBody);
    //         const data = await AcceptApprovalRequest(requestBody);

    //         //console.log("AcceptApprovalRequest:", data);
    //         navigate(`/thankyou?ReferenceNo=${referenceNo}`);
    //         // const list = data?.allApprovals || [];
    //         // setApprovals(list);

    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //         alert(error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // const SubmitRejectApprovalRequest = async (item) => {
    //     if (!item) {
    //         alert("Invalid approval data");
    //         return;
    //     }
    //     const { referenceNo, level1Approver, level1ApproverEmail, userId } = item;
    //     if (!referenceNo || !level1ApproverEmail) {
    //         alert("Missing required data");
    //         return;
    //     }

    //     const modalElement = document.getElementById("myModal");
    //     const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
    //     modalInstance.hide();
    //     setLoading(true);
    //     try {
    //         const requestBody = {
    //             referenceNo: referenceNo,
    //             level1ApproverEmal: level1ApproverEmail,
    //             level1Approver,
    //             product: "Flight",
    //             UserId: userId,
    //             remark: remark
    //         };
    //         //console.log("requestBody:", requestBody);
    //         const data = await RejectApprovalRequest(requestBody);
    //         alert(data.message);
    //         window.location.reload();
    //         setRemark("");
    //         setSelectedItem(null);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //         alert(error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const [timeLeft, setTimeLeft] = useState("");
    const getRemainingTime = (blockedOn) => {
        try {
            if (!blockedOn) return "Error";
            const blockTime = new Date(blockedOn);
            if (isNaN(blockTime)) return "Invalid Date";

            const expiryTime = new Date(blockTime.getTime() + 15 * 60000);

            const diff = expiryTime - new Date();

            if (diff <= 0) return "Expired";

            const m = Math.floor(diff / 60000);
            const s = Math.floor((diff % 60000) / 1000);

            return `${m}m ${s}s left`;
        } catch (error) {
            return "Error";
        }
    };

    const blockedOn = approvalDetails?.bookingStartTime;
    useEffect(() => {
        if (!blockedOn) {
            setTimeLeft("No Time");
            return;
        }
        setTimeLeft(getRemainingTime(blockedOn));
        const interval = setInterval(() => {
            setTimeLeft(getRemainingTime(blockedOn));
        }, 1000);
        return () => clearInterval(interval);
    }, [blockedOn]);
    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/approval" className="text-muted text-hover-primary">Approval</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>
                                <li class="breadcrumb-item text-gray-900">Approval Detail</li>

                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="d-flex align-items-center me-n2 me-lg-0">
                            <a class="btn btn-sm btn-primary me-3" href="/approval">
                                <i class="ki-outline ki-left fs-2"></i> Back To Approvals
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {
                (() => {

                    if (approvalDetails?.productType === "Flight" && Array.isArray(approvalDetails?.airBookingResponse) && approvalDetails.airBookingResponse.length > 0) {
                         return (
                            <FlightApprovalDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else if (approvalDetails?.productType === "Bus") {
                        return (
                            <BusApprovalDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else if (approvalDetails?.productType === "Hotel") {
                        return (
                            <HotelApprovalDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else if (approvalDetails?.productType === "Insurance") {
                        return (
                            <InsuranceApprovalDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else {
                        return <div>No data</div>;
                    }
                })()
            }



        </>
    )
};

export default ApprovalDetail;